module.exports = __webpack_public_path__ + "img/icon-delete.cfd02133.svg";